import { WorkItem, WorkItemStatus } from "@wingspanhq/wingspan-api-sdk";

export function filterActiveWorkItems(workItems: WorkItem[]): WorkItem[] {
  return workItems.filter(item => item.status !== WorkItemStatus.INACTIVE);
}
